<template>
  <th v-if="isHeader">
    <!--  -->
    Actions
  </th>
  <td v-else>
    <div>
      <dropdown>
        <dropdown-action success icon="edit" @click="onClickEdit" v-if="canEdit">Edit Group</dropdown-action>

        <dropdown-action
          danger
          icon="cross"
          @click="onClickDelete"
          v-if="canEdit"
        >Delete Group</dropdown-action>
      </dropdown>
    </div>
  </td>
</template>

<script>
import Dropdown from "./Dropdown";
import DropdownAction from "./DropdownAction";

import TrAction from "./TableRowAction";

import VuetableFieldMixin from "vuetable-2/src/components/VuetableFieldMixin";

export default {
  name: "user-actions",

  props: {
    rowData: Object
  },

  methods: {
    onClickEdit() {
      this.$router.push({
        name: "UserGroupsEdit",
        params: { groupId: this.rowData.id }
      });
    },

    onClickDelete() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        // TODO: This does the right thing, but do we need to create its own
        // method in the store so we can alter the confirmation etc.?
        confirm: () => {
          this.$store
            .dispatch("UserGroups/delete", vm.rowData.id)
            .then(resp => {
              this.$store.dispatch("UserGroups/list");
            });
        }
      });
    }
  },

  components: {
    Dropdown,
    DropdownAction,
    TrAction
  },

  mixins: [VuetableFieldMixin],

  computed: {
    canEdit() {
      return this.rowData.user_id == this.$store.state.auth.userId
    }
  },
};
</script>
